import { Link } from "@StarberryUtils";
import { get } from 'lodash';
import React,{useState, useEffect} from "react";
import {Row, Col, Container, ToggleButton } from 'react-bootstrap';
// import NewsCard from "../NewsCard/NewsCard"
import Subscribe from "../Subscribe/Subscribe"
import JoinMG from "../Subscribe/join-mg"
import ReactMarkdown from "react-markdown"
import  "./NewsPost.scss";
import VideoPlay from "../../Play/custom-video";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";

import { NewsDate } from "../../common/site/functions";

import { VIDEOS_PAGE_URL } from "../../common/site/constants";

import { GetURL } from "../../common/site/functions-update";
import ModalTiny from "react-bootstrap/Modal"
import AskquestionVideo from "../../forms/video-ask-question"
import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        ease: [0.33, 1, 0.68, 1],
        duration: 0.4
      }
    }
}
const containerItem = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      }
    }
}
const contentItem = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
}

const MotionRow = motion(Row)
const MotionCol = motion(Col)

const postsPerPage = 2;
let arrayForHoldingPosts = [];

const VideoPost =(props) => {
    const [modalAskformOpen,setAskformOpen] = React.useState(false);
    const showVideoListLayout = (get(props, 'pageContext.slug', '') === 'property-guide-videos')
    const openAskformModal = () => {
      setAskformOpen(true);
    }
    const closeAskformModal = () => {
      setAskformOpen(false);
    }


    const chunkSize = 6;
    const arr = props.data
    const groups = arr.map((e, i) => {
         return i % chunkSize === 0 ? arr.slice(i, i + chunkSize) : null;
    }).filter(e => { return e; });

    const [postsToShow, setPostsToShow] = useState([]);
    const [next, setNext] = useState(2);

    const loopWithSlice = (start, end) => {
        const slicedPosts = groups.slice(start, end);
        arrayForHoldingPosts = [...arrayForHoldingPosts, ...slicedPosts];
        setPostsToShow(arrayForHoldingPosts);
    };

    useEffect(() => {
        arrayForHoldingPosts = []
        loopWithSlice(0, postsPerPage);
    }, []);

    useEffect(() => {
        arrayForHoldingPosts = []
        loopWithSlice(0, postsPerPage);
    }, [props?.data?.length]);

    const handleShowMorePosts = () => {
        loopWithSlice(next, next + postsPerPage);
        setNext(next + postsPerPage);
    };
    const [toogleindex, setToogleindex] = useState(null)
    const toogleClick = (j) => {
        if(toogleindex === parseInt(j)){
            setToogleindex(null)
        }
        else {
            setToogleindex(parseInt(j))
        }
        var idelement = "tooglebk"+j
        setTimeout(function() {
        var elmnt = document.getElementById(idelement.toString());
        if(elmnt){
        elmnt.scrollIntoView();
        }
    }, 1);


    }


    return(
        <InView {...inViewOptions} threshold={0}>
            {({ ref, inView }) => (
                <motion.div
                    className="news-posts video-listing-landing"
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={container}
                >

                    <Container>
                        {showVideoListLayout && (
                            <Row>
                           <Col lg={12}>
                           {postsToShow.map((item, i) => {
                                  return (
                                   <React.Fragment key={i}>
                                       {item.map((news, j) => {
                                           return (
                                               <div id={"tooglebk"+j} className="video-title">
                                                   {news.Embed_Video_URL ? <VideoPlay toogleClick={toogleClick} j={j} titleOn={true} description={news.description} title={news.Title} url={news.Embed_Video_URL}/> : news.Content ? <a onClick={() => toogleClick(j)} href="javascript:void(0)">{news.Title}</a> : '' }
                                                   {news.Embed_Video_URL ? <VideoPlay toogleClick={toogleClick} j={j} isvideoplay={true} title={news.Title} url={news.Embed_Video_URL}/>  : news.Content ? <a onClick={() => toogleClick(j)} href="javascript:void(0)" className={j === toogleindex ? "plus-btn active" : "plus-btn"}><i className="icon-plus-icon"></i></a> : '' }
                                                   {j === toogleindex && news.Content ?
                                                   <div className="ritch-blk">
                                                       <ReactMarkdown source={news.Content} allowDangerousHtml className="editor"/>
                                                       </div>
                                                   : null
                                                   }
                                               </div>
                                           )
                                       }
                                       )}
                                       {i % 2 == 0 ? <div className="askaqustion-blk">
                                           <div>Need help? Ask one of our experts a question</div>
                                       <Link to="#" className="btn btn-default" onClick={openAskformModal}>ask a question</Link>
                                       </div> : null}
                                   </React.Fragment>
                                  )}
                           )}
                            <ModalTiny show={modalAskformOpen} backdrop="static" onHide={closeAskformModal} className="book-a-viewing-modal">
                           <ModalTiny.Header closeButton className="contact-close-btn">
                           <ModalTiny.Title className="w-100"><h2 className="text-center mb-0 text-uppercase">Ask a Question</h2></ModalTiny.Title>
                           </ModalTiny.Header>
                           <ModalTiny.Body className="event-section"><AskquestionVideo isVideosPage={true}  /></ModalTiny.Body>
                       </ModalTiny>

                           </Col>
                           </Row>
                        )}
                        {!showVideoListLayout && (
                        <Row>
                        <Col lg={12}>
                        {postsToShow.map((item, i) => {
                            return (
                            <React.Fragment key={i}>
                            {i % 2 == 0 ?
                            <>
                            {item.length >= 3 ? <>
                                <div className="main-post textingCon animate__animated">
                                    {item.slice(0,1).map((news, i) => {
                                    let page_url = ''
                                    if(props.url_tag != "static_inner")
                                    {
                                        page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                    }
                                    else if(props.url_tag == "career") {
                                        page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                    }
                                    else {
                                        page_url = news.URL
                                    }


                                    const image_url = news.Tile_Image.internal.description ? news.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';

                                    let processedImages = JSON.stringify({});
                                    if (news?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = news.imagetransforms.Tile_Image_Transforms;
                                    }

                                        return (
                                        <div className="main-item news-item col-md-12 col-lg-8 video-post-main" key={i}>
                                                <div className="news-card ">
                                                <div className="video-link">
                                                    <Link to={page_url}>
                                                        <figure className="news-img">
                                                            <ImageTransform imagesources={image_url} renderer="srcSet" imagename="videos.Tile_Image.tile_1" attr={{ alt: news.Title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={news.strapiId ? news.strapiId : news.id}/>
                                                        </figure>
                                                    </Link>

                                                    {news.Embed_Video_URL ? <VideoPlay title={news.Title} url={news.Embed_Video_URL}/> : '' }
                                                    </div>
                                                    <Link to={page_url}><strong className="news-title d-block">{news.Title}</strong></Link>
                                                    {news.description && news.description !== " " && <Link to={page_url}><p className="news-description">{news.description}</p></Link>}
                                                </div>
                                        </div>
                                        )
                                    })}

                                    <div className="vertical-item d-lg-block col-md-12 col-lg-4 video-post-sub">
                                    {item.slice(1,3).map((news, i) => {
                                    let page_url = ''
                                    if(props.url_tag != "static_inner")
                                    {
                                        page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                    }
                                    else if(props.url_tag == "career") {
                                        page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                    }
                                    else {
                                        page_url = news.URL
                                    }
                                    const image_url = news.Tile_Image.internal.description ? news.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';

                                    let processedImages = JSON.stringify({});
                                    if (news?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = news.imagetransforms.Tile_Image_Transforms;
                                    }
                                        return (
                                        <div className="news-item" key={i}>
                                                <div className="news-card ">
                                                <div className="video-link">
                                                    <Link to={page_url}><figure className="news-img">
                                                        <ImageTransform imagesources={image_url} renderer="srcSet" imagename="videos.Tile_Image.tile_1" attr={{ alt: news.Title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={news.strapiId ? news.strapiId : news.id}/>
                                                    </figure></Link>

                                                    {news.Embed_Video_URL ? <VideoPlay title={news.Title} url={news.Embed_Video_URL}/> : '' }
                                                    </div>
                                                    <Link to={page_url}><strong className="news-title d-block">{news.Title}</strong></Link>
                                                    {news.description && news.description !== " " && <Link to={page_url}><p className="news-description">{news.description}</p></Link>}
                                                </div>
                                        </div>
                                        )
                                    })}
                                    </div>
                                </div>

                                <div className="three-rw row">
                                    {item.slice(3,6).map((news, i) => {
                                    let page_url = ''
                                    if(props.url_tag != "static_inner")
                                    {
                                        page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                    }
                                    else if(props.url_tag == "career") {
                                        page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                    }
                                    else {
                                        page_url = news.URL
                                    }
                                    const image_url = news.Tile_Image.internal.description ? news.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';

                                    let processedImages = JSON.stringify({});
                                    if (news?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = news.imagetransforms.Tile_Image_Transforms;
                                    }
                                        return (
                                            <div className="news-item col-md-12 col-lg-4" key={i}>
                                                <div className="news-card ">
                                                <div className="video-link">
                                                    <Link to={page_url}><figure className="news-img">
                                                        <ImageTransform imagesources={image_url} renderer="srcSet" imagename="videos.Tile_Image.tile_1" attr={{ alt: news.Title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={news.strapiId ? news.strapiId : news.id}/>
                                                    </figure></Link>

                                                    {news.Embed_Video_URL ? <VideoPlay title={news.Title} url={news.Embed_Video_URL}/> : '' }
                                                    </div>
                                                    <Link to={page_url}><strong className="news-title d-block">{news.Title}</strong></Link>
                                                    {news.description && news.description !== " " && <Link to={page_url}><p className="news-description">{news.description}</p></Link>}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </> :
                                <div className="three-rw justify-content-between">
                                    <MotionRow variants={containerItem}>
                                    {item.slice(0,3).map((news, i) => {
                                    let page_url = ''
                                    if((props.url_tag != "static_inner") && (props.url_tag != "career"))
                                    {
                                        page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                    }
                                    else if(props.url_tag == "career") {
                                        page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                    }
                                    else {
                                        page_url = news.URL
                                    }
                                    const image_url = news.Tile_Image.internal.description ? news.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';

                                    let processedImages = JSON.stringify({});
                                    if (news?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = news.imagetransforms.Tile_Image_Transforms;
                                    }
                                        return (
                                        <MotionCol lg={4} key={i} variants={contentItem}>
                                            <div className="news-item news-list-row-3">
                                                <div className="news-card ">
                                                <div className="video-link">
                                                    <Link to={page_url}><figure className="news-img">
                                                        <ImageTransform imagesources={image_url} renderer="srcSet" imagename="videos.Tile_Image.tile_1" attr={{ alt: news.Title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={news.strapiId ? news.strapiId : news.id}/>
                                                    </figure></Link>
                                                    {news.Embed_Video_URL ? <VideoPlay title={news.Title} url={news.Embed_Video_URL}/> : '' }
                                                    </div>
                                                    <Link to={page_url}><strong className="news-title d-block">{news.Title}</strong></Link>
                                                    {news.description && news.description !== " " && <Link to={page_url}><p className="news-description">{news.description}</p></Link>}
                                                </div>
                                            </div>
                                        </MotionCol>
                                        )
                                    })}
                                    </MotionRow>
                                </div>
                            }


                                {i === 0 || i % 2 == 0  ? <>{props.url_tag != 'career' ? <Subscribe /> : <JoinMG />}</> : ''}
                            </>
                            : <>
                            {item.length >= 3 ? <>
                            <motion.div className="main-post2" variants={containerItem}>
                                <div className="vertical-item d-lg-block col-md-12 col-lg-4 video-post-sub-1">
                                    {item.slice(0,2).map((news, i) => {
                                    let page_url = ''
                                    if(props.url_tag != "static_inner")
                                    {
                                        page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                    }
                                    else if(props.url_tag == "career") {
                                        page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                    }
                                    else {
                                        page_url = news.URL
                                    }
                                    const image_url = news.Tile_Image.internal.description ? news.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';

                                    let processedImages = JSON.stringify({});
                                    if (news?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = news.imagetransforms.Tile_Image_Transforms;
                                    }
                                        return (
                                        <motion.div className="news-item" key={i} variants={contentItem}>
                                                <div className="news-card ">
                                                <div className="video-link">
                                                    <Link to={page_url}><figure className="news-img">
                                                        <ImageTransform imagesources={image_url} renderer="srcSet" imagename="videos.Tile_Image.tile_1" attr={{ alt: news.Title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={news.strapiId ? news.strapiId : news.id}/>
                                                    </figure></Link>
                                                    {news.Embed_Video_URL ? <VideoPlay title={news.Title} url={news.Embed_Video_URL}/> : '' }
                                                    </div>
                                                    <Link to={page_url}><strong className="news-title d-block">{news.Title}</strong></Link>
                                                    {news.description && news.description !== " " && <Link to={page_url}><p className="news-description">{news.description}</p></Link>}
                                                </div>
                                        </motion.div>
                                        )
                                    })}
                                </div>

                                {item.slice(2,3).map((news, i) => {
                                    let page_url = ''
                                    if(props.url_tag != "static_inner")
                                    {
                                        page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                    }
                                    else if(props.url_tag == "career") {
                                        page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                    }
                                    else {
                                        page_url = news.URL
                                    }
                                    const image_url = news.Tile_Image.internal.description ? news.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';

                                    let processedImages = JSON.stringify({});
                                    if (news?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = news.imagetransforms.Tile_Image_Transforms;
                                    }
                                    return (
                                        <motion.div className="main-item news-item col-md-12 col-lg-8 video-post-main-1" key={i} variants={contentItem}>
                                                <div className="news-card ">
                                                <div className="video-link">
                                                    <Link to={page_url}><figure className="news-img">
                                                        <ImageTransform imagesources={image_url} renderer="srcSet" imagename="videos.Tile_Image.tile_1" attr={{ alt: news.Title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={news.strapiId ? news.strapiId : news.id}/>
                                                    </figure></Link>
                                                    {news.Embed_Video_URL ? <VideoPlay title={news.Title} url={news.Embed_Video_URL}/> : '' }
                                                    </div>
                                                    <Link to={page_url}><strong className="news-title d-block">{news.Title}</strong></Link>
                                                    {news.description && news.description !== " " && <Link to={page_url}><p className="news-description">{news.description}</p></Link>}
                                                </div>
                                        </motion.div>
                                    )
                                })}
                            </motion.div>

                            <motion.div className="three-rw row" variants={containerItem}>
                                {item.slice(3,6).map((news, i) => {
                                    let page_url = ''
                                    if(props.url_tag != "static_inner")
                                    {
                                        page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                    }
                                    else if(props.url_tag == "career") {
                                        page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                    }
                                    else {
                                        page_url = news.URL
                                    }
                                    const image_url = news.Tile_Image.internal.description ? news.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';

                                    let processedImages = JSON.stringify({});
                                    if (news?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = news.imagetransforms.Tile_Image_Transforms;
                                    }
                                    return (
                                        <motion.div className="news-item col-md-12 col-lg-4" key={i} variants={contentItem}>
                                                <div className="news-card ">
                                                <div className="video-link">
                                                    <Link to={page_url}><figure className="news-img">
                                                        <ImageTransform imagesources={image_url} renderer="srcSet" imagename="videos.Tile_Image.tile_1" attr={{ alt: news.Title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={news.strapiId ? news.strapiId : news.id}/>
                                                    </figure></Link>
                                                    {news.Embed_Video_URL ? <VideoPlay title={news.Title} url={news.Embed_Video_URL}/> : '' }
                                                    </div>
                                                    <Link to={page_url}><strong className="news-title d-block">{news.Title}</strong></Link>
                                                    {news.description && news.description !== " " && <Link to={page_url}><p className="news-description">{news.description}</p></Link>}
                                                </div>
                                        </motion.div>
                                    )
                                })}
                            </motion.div></> :
                            <div className="three-rw justify-content-between">
                                <MotionRow variants={containerItem}>
                                {item.slice(0,3).map((news, i) => {
                                    let page_url = ''
                                    if(props.url_tag != "static_inner")
                                    {
                                        // if(news.Category == null)
                                        // {
                                        //     page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                        // }
                                        // else
                                        // {
                                        //     if(news.Category.Build_Separate_Page == true) {
                                        //     page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                        //     }
                                        //     else {
                                        //     page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.URL
                                        //     }
                                        // }
                                        page_url = VIDEOS_PAGE_URL.alias+'/'+news.Videos_Parent_Category.URL+'/'+news.URL
                                    }
                                    else if(props.url_tag == "career") {
                                        page_url = '/'+GetURL(news.Category.Choose_Category_Base_URL,props.menus)+'/'+news.Category.URL+'/'+news.URL
                                    }
                                    else {
                                        page_url = news.URL
                                    }
                                    const image_url = news.Tile_Image.internal.description ? news.Tile_Image.internal.description.replace("File ","").replace('"','').replace('"','') : '';

                                    let processedImages = JSON.stringify({});
                                    if (news?.imagetransforms?.Tile_Image_Transforms) {
                                        processedImages = news.imagetransforms.Tile_Image_Transforms;
                                    }
                                    return (
                                        <MotionCol lg={4} key={i} variants={contentItem}>
                                            <div className="news-item news-list-row-3">
                                                    <div className="news-card ">
                                                    <div className="video-link">
                                                        <Link to={page_url}><figure className="news-img">
                                                            <ImageTransform imagesources={image_url} renderer="srcSet" imagename="videos.Tile_Image.tile_1" attr={{ alt: news.Title+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={news.strapiId ? news.strapiId : news.id}/>
                                                        </figure></Link>
                                                        {news.Embed_Video_URL ? <VideoPlay title={news.Title} url={news.Embed_Video_URL}/> : '' }
                                                        </div>
                                                        <Link to={page_url}><strong className="news-title d-block">{news.Title}</strong></Link>
                                                        {news.description && news.description !== " " && <Link to={page_url}><p className="news-description">{news.description}</p></Link>}
                                                    </div>
                                            </div>
                                        </MotionCol>
                                    )
                                })}
                                </MotionRow>
                            </div> }
                            </>
                            }
                            </React.Fragment>
                            )
                        })}

                        </Col>
                        </Row>
                        )}
                        {arrayForHoldingPosts.length !== groups.length ?
                        <div className="load-more-cta">
                            <button onClick={handleShowMorePosts} className="btn d-block w-100">Load more</button>
                        </div> : ''
                        }

                    </Container>
                </motion.div>
            )}
        </InView>
    )
}

export default VideoPost;
